/**
 * @edms/contracts — vocabulaire partagé entre l'API et le client web.
 *
 * Aucune logique métier ici : uniquement des schémas, des types et les tables
 * de correspondance (libellés, transitions, permissions) qui doivent rester
 * rigoureusement identiques des deux côtés du réseau.
 */
export * from './primitives';
export * from './rbac';
export * from './organization';
export * from './identity';
export * from './scanning';
export * from './receipts';
export * from './ocr';
export * from './governance';
export * from './analytics';
/** Version du contrat, exposée dans l'en-tête `X-EDMS-Contract`. */
export const CONTRACT_VERSION = '1.0.0';
/** Préfixe unique de toutes les routes applicatives. */
export const API_PREFIX = '/api/v1';
//# sourceMappingURL=index.js.map